import { MenuItem } from '@mui/material'
import { IProducto } from '../types/producto'

interface ProductoActionsProps {
  producto: IProducto
  changingEstado: boolean
  isDefinitivelyDeleting?: boolean
}

const ProductoActions = ({producto, changingEstado, isDefinitivelyDeleting}: ProductoActionsProps) => {
  return (
    <>
      { !producto.aprobado && <MenuItem disabled={isDefinitivelyDeleting || changingEstado} onClick={producto.aprobar}>Aprobar</MenuItem> }
      { !producto.rechazado && <MenuItem disabled={isDefinitivelyDeleting || changingEstado} onClick={producto.rechazar}>Rechazar</MenuItem> }
      { !producto.pausado && <MenuItem disabled={isDefinitivelyDeleting || changingEstado} onClick={producto.pausar}>Pausar</MenuItem> }
      { producto.pausado && <MenuItem disabled={isDefinitivelyDeleting || changingEstado} onClick={producto.reanudar}>Reanudar</MenuItem> }
      <MenuItem sx={{color: 'red'}} disabled={isDefinitivelyDeleting || changingEstado} onClick={producto.borrar}>Borrar</MenuItem>
    </>
  )
}

export default ProductoActions